import {API} from 'aws-amplify';

function getMyInitiDocumentDb() {
    let myInitDb = {
        body: {
            database: 'db-pipeline',
            collection: 'report-embarcado-produto',
            command: 'find',
            sort: [["painelId", 1]],
            query: {
                cliente: "" + process.env.REACT_APP_X_TENANT_ID + ""
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDocumentUsersDb() {
    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'users_permission',
            command: 'find_one',
            query: {
                user: localStorage.getItem('tbClientes')
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

export default {
    getDashs: ({}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb()).then(response => {
            localStorage.setItem('dashboards', JSON.stringify(response.response));
            return response.response;
        }),

    getUserDetails: ({}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentUsersDb()).then(response => {
            //localStorage.setItem('dashboards', JSON.stringify(response.response));
            localStorage.setItem('typePermission', response.response.type);
            return response.response;
        }),

};
